export const environment = {
  production: true,
  endpoint : 'https://datosabiertos.mef.gob.pe/Rest'
};
